import { useState } from "react";
import { toast } from "sonner";
import { Loader2, HandHeart, ShieldAlert } from "lucide-react";
import { takeCharge } from "@/lib/alerts";
import { formatApiError } from "@/lib/api";
import { timeAgoFr } from "@/lib/format";

export default function TakeChargeBlock({ alert, user, onUpdated }) {
  const [loading, setLoading] = useState(false);
  const isOwner = alert.agent_id === user?.id;
  const taken = Boolean(alert.taken_by);

  if (taken) {
    return (
      <div
        className="sa-card flex items-start gap-3 px-4 py-4"
        data-testid="take-charge-taken"
      >
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white"
          style={{ background: "#22C55E" }}
        >
          <HandHeart size={18} />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="text-[13.5px] font-semibold text-slate-900">
            {alert.taken_by_name || "—"} prend en charge
          </span>
          <span className="text-[12px] text-slate-500">
            {timeAgoFr(alert.taken_at)} ·{" "}
            {alert.taken_by === user?.id ? "(vous)" : "responsable urgence"}
          </span>
        </div>
      </div>
    );
  }

  if (isOwner) {
    return (
      <div
        className="sa-card flex items-start gap-3 px-4 py-4"
        data-testid="take-charge-owner-info"
      >
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-600">
          <ShieldAlert size={18} />
        </div>
        <div className="flex flex-col">
          <span className="text-[13.5px] font-semibold text-slate-900">
            Vous êtes le déclencheur
          </span>
          <span className="text-[12px] text-slate-500">
            Un collègue va prendre en charge l'urgence dès qu'il aura ouvert l'alerte.
          </span>
        </div>
      </div>
    );
  }

  const onClick = async () => {
    setLoading(true);
    try {
      const updated = await takeCharge(alert.id);
      toast.success("Vous prenez en charge cette urgence.");
      onUpdated(updated);
    } catch (err) {
      toast.error(formatApiError(err));
      // Refresh anyway in case of 409 race
      try {
        const refreshed = await takeCharge.__refresh?.(alert.id);
        if (refreshed) onUpdated(refreshed);
      } catch (_e) {
        /* noop */
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      data-testid="take-charge-button"
      className="sa-card flex w-full items-center justify-center gap-2.5 px-4 py-4 text-[15px] font-bold text-white transition disabled:opacity-70"
      style={{
        background: "#22C55E",
        boxShadow: "0 6px 20px -6px rgba(34,197,94,0.55)",
        border: 0,
      }}
    >
      {loading ? <Loader2 size={18} className="animate-spin" /> : <HandHeart size={18} />}
      {loading ? "Enregistrement…" : "Je prends en charge l'urgence"}
    </button>
  );
}
